// ==================== RHYME HELPER ====================
export const RHYME_ENDINGS = {
  'ay': ['day', 'way', 'say', 'play', 'stay', 'away', 'today', 'okay', 'may', 'pay', 'ray', 'lay', 'hey', 'grey'],
  'ight': ['night', 'light', 'right', 'fight', 'sight', 'bright', 'tonight', 'might', 'tight', 'flight', 'white', 'write'],
  'ove': ['love', 'above', 'dove', 'shove', 'glove'],
  'eart': ['heart', 'start', 'part', 'art', 'apart', 'smart', 'cart', 'chart', 'dart'],
  'ound': ['sound', 'ground', 'found', 'around', 'bound', 'round', 'pound', 'wound', 'mound'],
  'ime': ['time', 'rhyme', 'climb', 'prime', 'crime', 'dime', 'chime', 'mime', 'slime'],
  'ine': ['mine', 'line', 'fine', 'shine', 'divine', 'wine', 'sign', 'nine', 'vine', 'spine', 'define'],
  'ow': ['know', 'go', 'show', 'flow', 'grow', 'glow', 'low', 'slow', 'snow', 'throw', 'below'],
  'all': ['call', 'fall', 'wall', 'all', 'small', 'tall', 'ball', 'hall', 'mall', 'crawl'],
  'est': ['best', 'rest', 'test', 'nest', 'quest', 'west', 'chest', 'guest', 'blessed', 'stressed', 'pressed'],
  'ong': ['song', 'long', 'strong', 'wrong', 'along', 'belong', 'throng'],
  'ain': ['rain', 'pain', 'train', 'brain', 'chain', 'gain', 'main', 'plain', 'strain', 'remain', 'explain'],
  'eam': ['dream', 'stream', 'team', 'cream', 'beam', 'seem', 'gleam', 'scheme', 'theme', 'extreme'],
  'eel': ['feel', 'real', 'deal', 'heal', 'steal', 'reveal', 'wheel', 'seal', 'meal', 'appeal'],
  'ire': ['fire', 'desire', 'higher', 'wire', 'tire', 'inspire', 'admire', 'entire', 'require'],
  'aze': ['blaze', 'days', 'ways', 'gaze', 'phase', 'praise', 'raise', 'craze', 'haze', 'amaze'],
  'ace': ['face', 'place', 'space', 'race', 'grace', 'trace', 'chase', 'embrace', 'replace'],
  'eak': ['break', 'speak', 'weak', 'peak', 'sneak', 'streak', 'freak', 'seek', 'cheek', 'creek'],
  'ade': ['made', 'fade', 'shade', 'blade', 'trade', 'grade', 'parade', 'afraid', 'evade'],
  'ore': ['more', 'door', 'floor', 'store', 'shore', 'before', 'explore', 'ignore', 'adore', 'restore'],
  'eep': ['deep', 'sleep', 'keep', 'weep', 'creep', 'steep', 'sweep', 'leap', 'cheap', 'heap'],
  'ue': ['true', 'blue', 'you', 'new', 'through', 'view', 'few', 'knew', 'grew', 'flew'],
  'ake': ['make', 'take', 'wake', 'break', 'shake', 'fake', 'lake', 'mistake', 'sake', 'ache'],
  'ear': ['hear', 'near', 'fear', 'clear', 'dear', 'year', 'tear', 'appear', 'disappear', 'sincere'],
  'ess': ['less', 'bless', 'mess', 'stress', 'guess', 'press', 'dress', 'express', 'confess', 'possess'],
  'urn': ['burn', 'turn', 'learn', 'earn', 'return', 'concern', 'yearn'],
  'ide': ['hide', 'side', 'ride', 'guide', 'wide', 'pride', 'slide', 'inside', 'decide', 'provide'],
  'an': ['man', 'can', 'plan', 'ran', 'fan', 'began', 'than', 'span', 'scan', 'ban'],
  'un': ['run', 'sun', 'fun', 'done', 'one', 'won', 'gun', 'begun', 'son', 'none'],
  'op': ['stop', 'drop', 'top', 'hop', 'pop', 'shop', 'crop', 'chop', 'nonstop'],
  'ack': ['back', 'black', 'track', 'crack', 'stack', 'pack', 'attack', 'lack', 'snack', 'whack'],
};

export const getRhymes = (word) => {
  if (!word) return [];
  const lower = word.toLowerCase().trim();
  if (lower.length < 2) return [];

  // Try to find matching ending
  for (const [ending, rhymes] of Object.entries(RHYME_ENDINGS)) {
    if (lower.endsWith(ending) || rhymes.includes(lower)) {
      return rhymes.filter(r => r !== lower).slice(0, 6);
    }
  }

  // Try partial ending match (last 2-3 letters)
  const last3 = lower.slice(-3);
  const last2 = lower.slice(-2);
  for (const [ending, rhymes] of Object.entries(RHYME_ENDINGS)) {
    if (ending.endsWith(last2) || last2.endsWith(ending.slice(-2))) {
      return rhymes.filter(r => r !== lower).slice(0, 6);
    }
  }

  // No match found - return message
  return ['(no rhymes found)'];
};
